/* src/app/ships/ship-logs/ship-logs.component.css */
/*# sourceMappingURL=ship-logs.component.css.map */
